// Centralized brand asset URLs and public contact details.
// Replace these to swap logo / video without touching components.

export const SITE = {
  name: "ForgeLayer AI",
  domain: "theforgelayer.com",
  url: "https://theforgelayer.com",
  contactEmail: "info@theforgelayer.com",
};

export const ASSETS = {
  logoLight:
    "https://customer-assets.emergentagent.com/job_e2a06597-7a6d-47fa-a1b3-cb42485ff15f/artifacts/jtp03k3r_ChatGPT%20Image%20May%2025%2C%202026%2C%2002_42_12%20AM.png",
  logoDark:
    "https://customer-assets.emergentagent.com/job_e2a06597-7a6d-47fa-a1b3-cb42485ff15f/artifacts/znqo9f3h_ChatGPT%20Image%20May%2025%2C%202026%2C%2002_44_39%20AM.png",
  // Primary H.264 MP4 (high quality, ~15MB) — supported in real Chrome/Safari/Firefox/Edge
  heroVideo:
    "https://customer-assets.emergentagent.com/job_e2a06597-7a6d-47fa-a1b3-cb42485ff15f/artifacts/qyjx8ugb_ElevenLabs_video_seedance-2-0_A%2010-second%2C..._2026-05-25T07_34_00.mp4",
  // VP9 WebM fallback (smaller, supported by all modern browsers + open-source Chromium)
  heroVideoWebm: "/media/hero.webm",
};

// Anchor placeholders — frontend-only. Wire to real destinations later (e.g. Calendly).
export const LINKS = {
  audit: "#audit",
  services: "#services",
  process: "#process",
  useCases: "#use-cases",
  contact: "#contact",
  // Primary CTAs reused by hero + final CTA section.
  getAudit: "#audit",
  seeBuild: "#services",
  // Reserved for later wiring (e.g. Calendly URL) — keep blank string so no
  // fabricated destination is sent to the user. Set in lib/brand.js when ready.
  strategyCallUrl: "",
};
